import protocolCheck from '~/modules/protocol-check.js';

angular
    .module('tradersyard')
    .factory('meetingEntrySingleton', function () {
        return {
            exhibitionEntryLoaded: false,
            webinarEntryLoaded: false,
            groupEntryLoaded: false,
        };
    })
    .controller('MeetingQueryCtrl', [
        '$scope',
        'MeetingManagerFactory',
        'GuidFactory',
        'graph-search-factory',
        '$timeout',
        'graph-meeting-factory',
        '$location',
        'includeEntryMeetingService',
        'graph-webinar-factory',
        'graph-group-factory',
        'graph-exhibition-factory',
        'WebSocket',
        'meetingEntrySingleton',
        'MeetingService',
        '$rootScope',
        'AuthService',
        'MeetingsStore',
        function (
            $scope,
            MeetingManagerFactory,
            GuidFactory,
            $search,
            $timeout,
            $meeting,
            $location,
            includeEntryMeetingService,
            webinarFactory,
            groupFactory,
            exhibitionFactory,
            $socket,
            meetingEntrySingleton,
            MeetingService,
            $rootScope,
            Auth,
            MeetingsStore
        ) {
            $scope.action = 'read';
            $scope.Meeting = MeetingManagerFactory.Singleton();
            $scope.Guid = GuidFactory.Generate();
            $scope.findData = [];
            $scope.proceed = true;
            $scope.findForm = { name: '' };
            $scope.participantRole = '';
            $scope.adminRoles = ['owner', 'executive', 'presenter'];
            $scope.chatsEntry = ['group', 'webinar'];
            // Needed to display a badge on the navbar icon
            $scope.unreadMessagesCount = 0;

            $scope.$on('participant:role', function (event, data) {
                $scope.$apply(function () {
                    $scope.participantRole = data;
                });
            });

            const unreadMessagesSumReducer = (sum, meeting) => sum + meeting.newMessageCount;

            // Not sure if this should be unsubscribed somewhere...
            MeetingsStore.meetings$
                .map((meetings) => meetings.reduce(unreadMessagesSumReducer, 0))
                .distinctUntilChanged()
                .subscribe((unreadMessagesCount) =>
                    $timeout(() => {
                        $scope.unreadMessagesCount = unreadMessagesCount;
                    })
                );

            /**
             * Call someone or join a group meeting.
             *
             * @param meeting
             * @returns {void}
             */
            this.callMeeting = function (meeting) {
                if ('user' === meeting.place.name) {
                    // If this is a private meeting we should start a Call procedure.
                    // It's like you are calling your friend on a Facebook Messenger.
                    MeetingService.startCall(meeting);
                    return;
                }

                MeetingService.joinMeeting(meeting);
            };

            this.isPrivateMeeting = function (meeting) {
                return meeting.type === 'private';
            };

            this.canMakeCall = function (meeting) {
                return meeting.type === 'private' && (meeting.place.location.can_contact || false);
            };

            this.isGroupMeeting = function (meeting) {
                return -1 !== ['community', 'webinar', 'exhibition', 'event'].indexOf(meeting.type);
            };

            $scope.selectAndShowConversation = function (node) {
                $scope.Meeting.Select(node);

                $rootScope.dropdown = 'undefined';
                $rootScope.$rootScope.showConversation = true;
            };

            setTimeout(function () {
                var meetingEntry = includeEntryMeetingService.getEntry();

                if (meetingEntry.entryName === 'exhibition') {
                    if (!meetingEntrySingleton.exhibitionEntryLoaded) {
                        meetingEntrySingleton.exhibitionEntryLoaded = true;
                        exhibitionFactory.meeting(meetingEntry.entryId).then(
                            function (response) {
                                if (response.data.state === 0) {
                                    response.data.data.meetingEntry = 'exhibition';

                                    $scope.Meeting.SetEntryId(response.data.data.id);

                                    $socket.emit('join:meeting', [response.data.data.id]);
                                    $scope.Meeting.Data.push(response.data.data);
                                    $scope.Meeting.Select(response.data.data);
                                    $scope.Meeting.Inited = true;
                                    $scope.Meeting.Query();
                                } else {
                                    $scope.Meeting.Inited = true;
                                    $scope.Meeting.Query();
                                }
                            },
                            function () {
                                $scope.Meeting.Inited = true;
                                $scope.Meeting.Query();
                            }
                        );
                    }
                } else if (meetingEntry.entryName === 'webinar') {
                    if (!meetingEntrySingleton.webinarEntryLoaded) {
                        meetingEntrySingleton.webinarEntryLoaded = true;
                        webinarFactory.meeting(meetingEntry.entryId).then(
                            function (response) {
                                if (response.data.state === 0) {
                                    response.data.data.meetingEntry = 'webinar';

                                    $scope.Meeting.SetEntryId(response.data.data.id);

                                    $socket.emit('join:meeting', [response.data.data.id]);
                                    $scope.Meeting.Data.push(response.data.data);
                                    $scope.Meeting.Select(response.data.data);
                                    $scope.Meeting.Inited = true;
                                    $scope.Meeting.Query();
                                } else {
                                    $scope.Meeting.Inited = true;
                                    $scope.Meeting.Query();
                                }
                            },
                            function () {
                                $scope.Meeting.Inited = true;
                                $scope.Meeting.Query();
                            }
                        );
                    }
                } else if (meetingEntry.entryName === 'group') {
                    if (!meetingEntrySingleton.groupEntryLoaded) {
                        meetingEntrySingleton.groupEntryLoaded = true;
                        groupFactory.meeting(meetingEntry.entryId).then(
                            function (response) {
                                if (response.data.state === 0) {
                                    response.data.data.meetingEntry = 'group';

                                    $scope.Meeting.SetEntryId(response.data.data.id);

                                    $socket.emit('join:meeting', [response.data.data.id]);
                                    $scope.Meeting.Inited = true;
                                    $scope.Meeting.Data.push(response.data.data);
                                    $scope.Meeting.Select(response.data.data);
                                    $scope.Meeting.Query();
                                } else {
                                    $scope.Meeting.Inited = true;
                                    $scope.Meeting.Query();
                                }
                            },
                            function () {
                                $scope.Meeting.Inited = true;
                                $scope.Meeting.Query();
                            }
                        );
                    }
                } else {
                    $socket.emit('join:meeting', [0]);

                    $scope.Meeting.Inited = true;
                    $scope.Meeting.Query();
                }
            });

            $scope.onKeyUpFind = function ($event) {
                if ($event.keyCode === 27) {
                    $scope.openRead();
                }
            };

            $scope.userCanDeleteMessage = function (message, meetingEntry) {
                if (!Auth.isUserAuthenticated()) {
                    return false;
                }

                if (
                    message.owner.id === $rootScope.me.id ||
                    ($scope.chatsEntry.includes(meetingEntry) && $scope.adminRoles.includes($scope.participantRole))
                ) {
                    return true;
                }

                return false;
            };

            $scope.openDropdown = function (messageId) {
                var messageKey = 'message.' + messageId;

                return dropdown === messageKey ? undefined : messageKey;
            };

            $scope.openFind = function () {
                $scope.action = 'find';
            };

            $scope.openRead = function () {
                $scope.action = 'read';
            };

            $scope.isReadAction = function () {
                return $scope.action === 'read';
            };
            $scope.isFindAction = function () {
                return $scope.action === 'find';
            };

            $scope.find = function (next) {
                $scope.proceed = false;

                $search
                    .entry('friend')
                    .search({
                        params: {
                            q: $scope.findForm.name,
                        },
                    })
                    .then(function (response) {
                        if (response.data.state === 0 && response.data.data.length > 0) {
                            $scope.findData = response.data.data;

                            if (next) {
                                next();
                            }
                        }

                        $scope.proceed = true;

                        if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                            $scope.$apply();
                        }
                    });
            };

            var t, wait;

            $scope.$watch(
                function () {
                    return $scope.findForm.name;
                },
                function (val, $nval) {
                    if (val !== $nval) {
                        wait = 1;
                        if (t) $timeout.cancel(t);

                        t = $timeout(function () {
                            $scope.find();
                        }, 0);
                    }
                }
            );

            $scope.friendMeeting = function (userNode) {
                $meeting.friend(userNode.id).then(function (response) {
                    if (response.data.state === 0) {
                        $scope.Meeting.Select(response.data.data);
                    } else {
                        //
                    }
                });
            };
        },
    ])
    .controller('MeetingGroupCtrl', [
        '$scope',
        'MeetingManagerFactory',
        'GuidFactory',
        'graph-group-factory',
        'WebSocket',
        function ($scope, MeetingManagerFactory, GuidFactory, Api, $socket) {
            $scope.Meeting = MeetingManagerFactory.Instance();
            $scope.Guid = GuidFactory.Generate();
            $scope.Exists = 0;

            $scope.Load = function (node) {
                if ($scope.Exists !== 1) {
                    Api.meeting(node.id).then(function (response) {
                        if (response.data.state === 0) {
                            $socket.emit('join:meeting', [response.data.data.id]);

                            $scope.Exists = 1;
                            $scope.Meeting.Data = [response.data.data];
                            $scope.Meeting.Select(response.data.data);
                        }
                    });
                }
            };
        },
    ])
    .controller('MeetingWebinarCtrl', [
        '$scope',
        'MeetingManagerFactory',
        'GuidFactory',
        'graph-webinar-factory',
        'WebSocket',
        function ($scope, MeetingManagerFactory, GuidFactory, Api, $socket) {
            $scope.Meeting = MeetingManagerFactory.Instance();
            $scope.Guid = GuidFactory.Generate();
            $scope.Exists = 0;

            $scope.Load = function (node) {
                if ($scope.Exists !== 1) {
                    Api.meeting(node.id).then(function (response) {
                        if (response.data.state === 0) {
                            $socket.emit('join:meeting', [response.data.data.id]);

                            $scope.Exists = 1;
                            $scope.Meeting.Data = [response.data.data];
                            $scope.Meeting.Select(response.data.data);
                        }
                    });
                }
            };
        },
    ])
    .controller('PublicMeetingController', [
        '$rootScope',
        '$scope',
        'MeetingManagerFactory',
        'GuidFactory',
        'WebSocket',
        function ($rootScope, $scope, MeetingManagerFactory, GuidFactory, $socket) {
            $rootScope.$rootScope = { isRootMeetingPage: false };
            $scope.Meeting = MeetingManagerFactory.Instance();
            $scope.Guid = GuidFactory.Generate();
            $scope.Exists = 0;

            $scope.Load = function (node) {
                if ($scope.Exists !== 1) {
                    $socket.emit('join:meeting', [0]);

                    $scope.Exists = 1;
                    $scope.Meeting.Data = [{ id: 0 }];
                    $scope.Meeting.Select({ id: 0 });
                }
            };
        },
    ])
    .controller('SelectMeetingClientController', [
        '$scope',
        '$timeout',
        'MeetingService',
        function ($scope, $timeout, MeetingService) {
            $scope.pageView = 'signIn'; // possible 'signIn', 'signUp'

            $scope.opened = false;
            $scope.loader = false;
            $scope.formError = {};

            /**
             * Room info passed as event data when selection modal is opened
             * @type {{roomType: string, roomTypeId: number}}
             */
            $scope.roomInfo = {};

            $scope.$on('open:select-meeting-client:dialog', function (event, data) {
                $scope.meetingClientUrn = data.meetingClientUrn;
                $scope.installClientUri = data.installClientUri;
                $scope.roomInfo = data.roomInfo;

                $scope.opened = true;

                if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                    $scope.$apply();
                }
            });

            $scope.protocolError = false;

            $scope.requestMeetingClient = function () {
                $scope.loader = true;

                protocolCheck(
                    'ty-client-v1://' + $scope.meetingClientUrn,
                    function () {
                        window.location = $scope.installClientUri;

                        $timeout(function () {
                            $scope.opened = false;
                            $scope.loader = false;
                        }, 0);
                    },
                    function () {
                        $timeout(function () {
                            $scope.opened = false;
                            $scope.loader = false;
                        }, 0);
                    }
                );
            };

            $scope.requestAgenaTrader = function () {
                $scope.protocolError = false;
                $scope.loader = true;

                protocolCheck(
                    'ty-agenatrader-v1://' + $scope.meetingClientUrn,
                    function () {
                        $scope.protocolError = true;

                        if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                            $timeout(function () {
                                $scope.loader = false;
                            }, 0);
                        }
                    },
                    function () {
                        $timeout(function () {
                            $scope.opened = false;
                            $scope.loader = false;
                        }, 0);
                    }
                );
            };

            /**
             * Opens a small window where user will wait for authentication to join meeting room.
             * On success, the user is redirected to a Choop Chat meeting room.
             */
            $scope.requestWebClient = function () {
                MeetingService.openMeetingWindow($scope.roomInfo.roomType, $scope.roomInfo.roomTypeId);
            };

            $scope.requestWebClientIframe = function () {
                $scope.opened = false;
                MeetingService.triggerMeetingIframe($scope.roomInfo.roomType, $scope.roomInfo.roomTypeId);
            };

            $scope.closeDialog = function () {
                $scope.opened = false;
            };

            document.addEventListener('keyup', function (e) {
                if (e.keyCode === 27 && $scope.opened) {
                    $scope.opened = false;
                    if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                        $scope.$apply();
                    }
                }
            });
        },
    ])
    .controller('SelectParticipantExpireController', [
        '$scope',
        function ($scope) {
            $scope.opened = false;
            $scope.dateConfig = {
                minDate: moment(),
                dateFormat: 'YYYY-MM-DD',
            };

            $scope.expire = null;
            $scope.node = null;
            $scope.service = null;

            $scope.$on('open:select-participant-expire:dialog', function ($event, $data) {
                $scope.opened = true;
                $scope.node = $data.node;
                $scope.expire =
                    $scope.node.expired_at !== null
                        ? moment($scope.node.expired_at).format('YYYY-MM-DD')
                        : moment().add(1, 'days').format('YYYY-MM-DD');
                $scope.service = $data.service;
            });

            $scope.closeDialog = function () {
                $scope.opened = false;
                $scope.service = null;
                $scope.node = null;
                $scope.expire = null;
            };

            $scope.saveExpire = function () {
                $scope.service.Expire($scope.node.id, $scope.expire, function () {
                    $scope.node.expired_at = $scope.expire;
                    $scope.closeDialog();
                });
            };
        },
    ])
    .controller('AssignRoleController', [
        '$scope',
        'graph-api-client',
        '$rootScope',
        function ($scope, $client, $root) {
            $scope.opened = false;
            $scope.dateConfig = {
                minDate: moment(),
                dateFormat: 'YYYY-MM-DD',
            };

            $scope.roles = [];
            $scope.currentRole = null;
            $scope.node = null;
            $scope.entry = null;

            $scope.$on('open:assign-role:dialog', function ($event, $data) {
                $scope.opened = true;
                $scope.node = $data.node;
                $scope.role = $data.node.role;
                if ($data.entry.type === 'group') {
                    $scope.roles = ['owner', 'executive', 'presenter', 'trader', 'pretrader', 'listener'];
                } else {
                    $scope.roles = ['owner', 'pretrader', 'presenter', 'listener'];
                }

                $scope.entry = $data.entry;
            });

            $scope.closeDialog = function () {
                $scope.opened = false;
                $scope.service = null;
                $scope.node = null;
                $scope.expire = null;
            };

            $scope.save = function () {
                $client
                    .post([$scope.entry.type, $scope.entry.id, 'participant', $scope.node.id], { role: $scope.role })
                    .then(function () {
                        $root.$broadcast('role-change', {
                            entry: $scope.entry.type,
                            role: $scope.role,
                            id: $scope.node.id,
                        });
                        $scope.closeDialog();
                    })
                    .catch(function (error) {
                        $scope.closeDialog();
                        $root.$broadcast('graph-modal-show', {
                            title: 'Error',
                            content: error.data.data.message,
                        });
                    });
            };
        },
    ])
    .controller('ConfirmRemoveParticipantController', [
        '$scope',
        function ($scope) {
            $scope.opened = false;

            $scope.node = null;
            $scope.service = null;

            $scope.$on('open:confirm-participant-remove:dialog', function ($event, $data) {
                $scope.opened = true;
                $scope.node = $data.node;
                $scope.service = $data.service;
            });

            $scope.closeDialog = function () {
                $scope.opened = false;
                $scope.service = null;
                $scope.node = null;
            };

            $scope.removeParticipant = function () {
                $scope.service.Remove($scope.node.id, function () {
                    $scope.closeDialog();
                    location.reload();
                });
            };
        },
    ]);
